<div class="simple-dialog">
    <div class="dialog-header">
      <div class="icon">
        <img src="../../../../assets/images/icons/warning.png" alt="Warning" />
      </div>
      <h2>Mandatory Action Required</h2>
    </div>

    <div class="dialog-content">
      <p>
        Please note that this page must be added or updated for all supported
        languages to maintain consistency across translations.
      </p>
    </div>

    <div class="dialog-actions">
      <button mat-button class="cancel-btn" (click)="onCancel()">Cancel</button>
      <button mat-raised-button class="continue-btn" (click)="onContinue()">Continue</button>
    </div>
  </div>
